export default function getFactor(el: HTMLDivElement | SVGSVGElement): number {
    const clientRect = el.getBoundingClientRect()
    return (((clientRect.top + clientRect.height / 2) / window.innerHeight) - 0.5) * 2
}
